export function inEnum<E extends string>(string: string, enumeration: Record<string, E>): string is E {
	return Object.values(enumeration).includes(string as E);
}
